import { Auth, Google, Firestore } from "../../config/firebase";

class Authenticate {
  SignUp(user) {
    const email = user.email;
    const password = user.password;
    return Auth.createUserWithEmailAndPassword(email, password)
      .then(res => {
        Firestore.doc(`users/${res.user.uid}`).set({
          displayName: user.name,
          email: res.user.email,

          role: "user"
        });
        this._updateUserData(user.name);

        console.log(res, "auth page");
      })
      .catch(error => {
        throw error;
      });
  }

  _updateUserData(user) {
    var userNow = Auth.currentUser;
    userNow
      .updateProfile({
        displayName: user
      })
      .then(
        function() {
          var displayName = userNow.displayName;
        },
        function(error) {}
      );
  }

  SignIn(user) {
    const email = user.email;
    const password = user.password;
    return Auth.signInWithEmailAndPassword(email, password)
      .then(res => true)
      .catch(error => {
        throw error;
      });
  }

  SignOut(user) {
    return Auth.signOut()
      .then(res => true)
      .catch(error => {
        throw error;
      });
  }
  SignInWithGoogle() {
    return Auth.signInWithPopup(Google)
      .then(res =>
        Firestore.doc(`users/${res.user.uid}`).set({
          displayName: res.user.displayName,
          email: res.user.email,
          role: "user"
        })
      )
      .catch(error => {
        throw error;
      });
  }

  UpdateUser(update) {
    const User = Auth.currentUser;
    User.UpdateUser(update)
      .then(res => true)
      .catch(error => {
        throw error;
      });
  }
  FindUser(ID) {
    return Firestore.collection("users")
      .doc(ID)
      .get()
      .then(doc => {
        return doc.data();
      });
  }
}

export default new Authenticate();
